import { ActionRegistryCategory } from '../../ActionRegistryCategory';
import { ActionsMultipleChoice } from '../../../../questiontype/MultipleChoice/registry/ActionsMultipleChoice';
import { ActionsKnowAWord } from '../../../../questiontype/KnowAWord/registry/ActionsKnowAWord';
import { ActionsOrderedTask } from '../../../../questiontype/OrderedChoice/registry/ActionsOrderedTask';
export class ActionsQuestion extends ActionRegistryCategory {
    label = 'Frage';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_mc = new ActionsMultipleChoice(this);
    c_kw = new ActionsKnowAWord(this);
    c_oc = new ActionsOrderedTask(this);
}
